import React from 'react'
//import logo from '../../styles/images/logo-propublica-sq.svg'
import logo from '../../styles/images/logo-propublica-illinois.svg'

const ProPublicaHeader = (props) => {
  return (
    <header className="site-mast-mini">
      <div className="mast-main mast-inner">
          <div className="mast-content">
            <div className="project-name">
              <h4><a href="https://www.propublica.org/nerds/illinois-governor-race-campaign-finance-widget-2018" target="_parent">
                The Money Game
              </a></h4>
              <p>Tracking the Illinois Governor's Race</p>
            </div>
            <div className="last-updated">
              <a className="site-logo" target="_parent" href="http://propublica.org/illinois">
                <img src={logo} alt="ProPublica Illinois logo" />
              </a>
            </div>
          </div>
      </div>
    </header>
  )
}

export default ProPublicaHeader



// WEBPACK FOOTER //
// ./src/components/ProPublicaHeader/index.js